import { supabase } from '../lib/supabase';

export const membershipService = {
  /**
   * Upgrade user to PRO membership
   * @param {string} userId - User ID to upgrade
   * @returns {Promise<Object>} Updated user profile
   */
  async upgradeToPro(userId) {
    try {
      const { data, error } = await supabase?.from('user_profiles')?.update({ 
          membership_tier: 'pro'
        })?.eq('id', userId)?.select()?.single();

      if (error) throw error;

      return { success: true, data };
    } catch (error) {
      console.error('Error upgrading to PRO:', error);
      return { success: false, error: error?.message };
    }
  },

  /**
   * Downgrade user to free membership
   * @param {string} userId - User ID to downgrade
   * @returns {Promise<Object>} Updated user profile
   */
  async downgradeToFree(userId) {
    try {
      const { data, error } = await supabase?.from('user_profiles')?.update({ 
          membership_tier: 'free'
        })?.eq('id', userId)?.select()?.single();

      if (error) throw error;

      return { success: true, data };
    } catch (error) {
      console.error('Error downgrading to free:', error);
      return { success: false, error: error?.message };
    }
  },

  /**
   * Get user membership status
   * @param {string} userId - User ID
   * @returns {Promise<Object>} User membership info
   */
  async getMembershipStatus(userId) {
    try {
      const { data, error } = await supabase?.from('user_profiles')?.select('membership_tier')?.eq('id', userId)?.single();

      if (error) throw error;

      return { 
        success: true, 
        isPro: data?.membership_tier === 'pro',
        tier: data?.membership_tier 
      };
    } catch (error) {
      console.error('Error getting membership status:', error);
      return { success: false, error: error?.message };
    }
  }
};